import { Currency } from '../../constants/currency.js';
import { getAmountRangeToString } from '../../helpers/humanization.js';

const getSavingsTerms = item => {
    const conditions = [];
    const { term, rate, amount } = item;
    const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB });
    conditions.push({ value: rate, description: 'Cтавка в год', key: 'rate' });
    conditions.push({ value: amountValue, description: 'Сумма вклада', key: 'amount' });
    conditions.push({ value: term, description: 'Срок', key: 'term' });
    return conditions;
};

export { getSavingsTerms };
//# sourceMappingURL=savings.js.map
